export function answerEntries(answers) {
  if (!answers || typeof answers !== "object" || Array.isArray(answers)) return [];
  return Object.entries(answers).filter(([, value]) => typeof value === "string");
}
export function updateDraftAnswer(drafts, id, question, value) {
  return drafts.map((draft) => draft.id === id && draft.status === "draft" ?
    { ...draft, answers: { ...Object.fromEntries(answerEntries(draft.answers)), [question]: value } } : draft);
}
